import { AWSC } from "@/config/types/common";
import { loadScript } from "./utils";

interface RobotCaptchaProps {
  elementId: string;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
  onLoaded?: () => void; // 验证码加载完毕
  props?: any;
}

class RobotCaptcha {
  private create({ elementId, props, onSuccess, onError }: RobotCaptchaProps) {
    const container = document.getElementById(elementId);
    if (!container) {
      onError?.(new Error(`[@italent/ali-robot-captcha] selector is null`));
      return;
    }

    // 业务请求结果回调函数
    function onBizResultCallback(bizResult: boolean) {
      console.info("bizResult", bizResult);
      if (bizResult) {
        // onSuccess?.(this.);
      }
    }

    function captchaVerifyCallback(captchaVerifyParam: string) {
      console.info(captchaVerifyParam);
      if (captchaVerifyParam) {
        onSuccess?.(captchaVerifyParam);
        return {
          captchaResult: true, // 验证码验证是否通过，boolean类型，必选
        };
      } else {
        onError?.("拖动验证失败");
        return {
          captchaResult: false, // 验证码验证是否通过，boolean类型，必选
        };
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let captcha: any;
    function getInstance(instance: any) {
      captcha = instance;
    }

    window.initAliyunCaptcha({
      ...AWSC,
      mode: "embed", // 验证码模式。embed表示要集成的验证码模式为嵌入式。无需修改
      element: `#${elementId}`, // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: "#button", // 触发业务请求的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 320,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      immediate: true, // 完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）
      region: "cn", //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
      ...props,
    });
  }

  show({ onLoaded, ...rest }: RobotCaptchaProps) {
    const scriptId = "ali-cpatcha";

    if (document.getElementById(scriptId)) {
      this.create(rest);
      onLoaded?.();
    } else {
      loadScript({
        url: "https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js",
        id: scriptId,
        onSuccess: () => {
          console.info(window.initAliyunCaptcha);
          this.create(rest);
          onLoaded?.();
        },
      });
    }
  }
}

const robotCaptcha = new RobotCaptcha();
export default robotCaptcha;
